export function getPinkSlipAddresses() {
  return {
    type: 'GET_PINK_SLIPS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/address/getAddress',
            mock: false,
          },
        },
        commit: {
          type: 'GET_PINK_SLIPS_COMMIT',
        },
        rollback: {
          type: 'GET_PINK_SLIPS_ROLLBACK',
        },
      },
    },
  }
}

export function sendPinkSlipAddress(address) {
  return {
    type: 'SEND_PINK_SLIPS',
    payload: address,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            base: '/mailto/document',
            mock: false,
          },
        },
        commit: {
          type: 'SEND_PINK_SLIPS_COMMIT',
        },
        rollback: {
          type: 'SEND_PINK_SLIPS_ROLLBACK',
        },
      },
    },
  }
}

export function setPinkSlipAddress(address) {
  return {
    type: 'SET_PINK_SLIP_ADDRESS',
    payload: { address },
  }
}
